import { Home } from "lucide-react";
import { Button } from "../ui/button";
interface OrderActionsProps {
  onContinueShopping: () => void;
  onTrackOrder: () => void;
}
export const OrderActions = ({ onContinueShopping }: OrderActionsProps) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-5 py-4 z-50">
      <div className="space-y-3">
        {/* Continue Shopping Button */}
        <Button
          onClick={onContinueShopping}
         className="w-full h-12 font-semibold rounded-full flex items-center justify-center gap-2"
        >
          <Home className="w-5 h-5" />
          Continue Shopping
        </Button>
      </div>
    </div>
  );
};